import React, { useState, useRef } from 'react';
import styles from '../../WabaChats.module.scss';

const SendIcon = () => (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
        <path d="M1.101 21.757 23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z" />
    </svg>
);

const AttachIcon = () => (
    <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
        <path d="M1.816 15.556v.002c0 1.502.584 2.912 1.646 3.972s2.472 1.647 3.974 1.647a5.58 5.58 0 0 0 3.972-1.645l9.547-9.548c.769-.768 1.147-1.767 1.058-2.817-.079-.968-.548-1.927-1.319-2.698-1.594-1.592-4.068-1.711-5.517-.262l-7.916 7.915c-.881.881-.792 2.25.214 3.261.501.501 1.171.769 1.876.769.428 0 .845-.138 1.162-.411l5.557-5.557c.234-.235.234-.615 0-.849a.601.601 0 0 0-.849 0l-5.557 5.555a.899.899 0 0 1-.632.269c-.356 0-.755-.215-1.057-.518-.639-.637-.625-1.317-.171-1.769l7.916-7.917c.94-.94 2.588-.862 3.672.222.503.504.826 1.145.878 1.787.063.757-.208 1.404-.752 1.946l-9.547 9.549a3.97 3.97 0 0 1-2.829 1.171 3.975 3.975 0 0 1-2.83-1.171 3.973 3.973 0 0 1-1.17-2.828l.001-.001a3.97 3.97 0 0 1 1.171-2.829L15.237 3.1c.234-.234.234-.614 0-.849a.601.601 0 0 0-.849 0L5.547 11.09a5.567 5.567 0 0 0-1.645 3.971l-.086.495z" />
    </svg>
);

const CloseIcon = () => (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
        <path d="M19.1 4.9C18.7 4.5 18.1 4.5 17.7 4.9L12 10.6 6.3 4.9C5.9 4.5 5.3 4.5 4.9 4.9 4.5 5.3 4.5 5.9 4.9 6.3L10.6 12 4.9 17.7C4.5 18.1 4.5 18.7 4.9 19.1 5.3 19.5 5.9 19.5 6.3 19.1L12 13.4 17.7 19.1C18.1 19.5 18.7 19.5 19.1 19.1 19.5 18.7 19.5 18.1 19.1 17.7L13.4 12 19.1 6.3C19.5 5.9 19.5 5.3 19.1 4.9z" />
    </svg>
);

export default function MessageInput({ onSend, onSendMedia, disabled = false }) {
    const [text, setText] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (disabled) return;
        if (selectedFile) {
            onSendMedia(selectedFile);
            setSelectedFile(null);
            if (fileInputRef.current) fileInputRef.current.value = '';
        } else if (text.trim()) {
            onSend(text);
            setText('');
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(e);
        }
    };

    const handleFileSelect = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            setSelectedFile(file);
        }
    };

    const clearFile = () => {
        setSelectedFile(null);
        if (fileInputRef.current) fileInputRef.current.value = '';
    };

    return (
        <div>
            {selectedFile && !disabled && (
                <div className={styles.filePreview}>
                    <span className={styles.fileName}>{selectedFile.name}</span>
                    <button className={styles.fileClearBtn} onClick={clearFile} type="button">
                        <CloseIcon />
                    </button>
                </div>
            )}
            <form className={styles.messageInput} onSubmit={handleSubmit}>
                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileSelect}
                    style={{ display: 'none' }}
                    accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.zip"
                    disabled={disabled}
                />
                <button type="button" className={styles.attachBtn} onClick={() => fileInputRef.current?.click()} title="Прикрепить файл" disabled={disabled}>
                    <AttachIcon />
                </button>
                <textarea
                    className={styles.inputField}
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder={disabled ? "Окно для ответа закрыто" : (selectedFile ? "Нажмите «Отправить», чтобы загрузить файл..." : "Введите сообщение...")}
                    rows={1}
                    disabled={disabled || !!selectedFile}
                />
                <button type="submit" className={styles.sendButton} disabled={disabled || (!text.trim() && !selectedFile)} title="Отправить">
                    <SendIcon />
                </button>
            </form>
        </div>
    );
}
